export class SchedulerBookingModel {
  sharedVehicleGroupHashId: string = '';
  vehicleHashId: string = '';
  licenceTag: string;
  startDateTime: string;
  endDateTime: string;
  id: string;
  title: string;
  start: string;
  end: string;
  className: string;
  url: string;
  toggleOption: boolean = true;
  driverName: string;
  mobile: string;
  email: string;
  bookingReferenceID:string;
  bookingHashId:string;
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/booking/models/schedular-booking.model.ts